import { Typography } from '@mui/material';
import React from 'react';
/**
 * A placeholder element for drag-and-drop targets.
 *
 * @param {React.PropsWithChildren} props - The properties passed to the component, including children to be rendered inside the placeholder.
 * @returns {JSX.Element} A styled placeholder element used as a visual drag target in a UI.
 */
export const DragTargetPlaceholder = (props) => {
    return (React.createElement(Typography, { "data-drag-target-placeholder": true, sx: { p: '7px', border: '2px dashed rgba(0, 0, 0, 0.1)', color: 'text.disabled' } }, props.children));
};
